import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"min-width":"40vw"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingConnector = _resolveComponent("SettingConnector")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ConnectedBankAccountCard = _resolveComponent("ConnectedBankAccountCard")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_AddConnector = _resolveComponent("AddConnector")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectors_, (connection, index) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            cols: _ctx.colWidth,
            key: index,
            class: "my-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SettingConnector, _mergeProps({ ref_for: true }, connection, {
                active: connection.isActive || false,
                enableSync: connection.enableSync || false,
                companyId: _ctx.companyId,
                comingSoon: connection.comingSoon || false,
                logo: _ctx.getLogo(connection.application) || '',
                externalId: connection.externalId || '',
                disableConfiguration: connection.disableConfiguration || false,
                dense: _ctx.dense,
                onUpdateProfile: _cache[0] || (_cache[0] = (configValue) => _ctx.upsertSetting(configValue)),
                onConnectorDeleted: _cache[1] || (_cache[1] = (connectorId) => _ctx.removeDeleted(connectorId))
              }), null, 16, ["active", "enableSync", "companyId", "comingSoon", "logo", "externalId", "disableConfiguration", "dense"])
            ]),
            _: 2
          }, 1032, ["cols"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectedBankAccounts, (account) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            cols: _ctx.colWidth,
            key: account.id,
            class: "my-2"
          }, {
            default: _withCtx(() => [
              (account.budgetInsightId)
                ? (_openBlock(), _createBlock(_component_ConnectedBankAccountCard, {
                    key: 0,
                    bankAccount: account,
                    dense: _ctx.dense
                  }, null, 8, ["bankAccount", "dense"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["cols"]))
        }), 128)),
        (_ctx.displayAddConnectorCard)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: _ctx.colWidth,
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "d-flex align-end flex-column default_card elevation-0 fill-height mx-2" }, {
                  default: _withCtx(() => [
                    (_ctx.isTrainingOffer)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 0 }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_card_text, _mergeProps(props, { class: "fill-height d-flex align-center justify-center w-100" }), {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  disabled: true,
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { class: "mr-2" }, {
                                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                                        _createTextVNode("$fa-plus")
                                      ])),
                                      _: 1
                                    }),
                                    _cache[5] || (_cache[5] = _createTextVNode(" Ajouter un connecteur "))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("training-text.normal-text")), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 1,
                          class: "fill-height d-flex align-center justify-center w-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addConnector = true)),
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { class: "mr-2" }, {
                                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createTextVNode("$fa-plus")
                                  ])),
                                  _: 1
                                }),
                                _cache[7] || (_cache[7] = _createTextVNode(" Ajouter un connecteur "))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_oss_dialog, {
                  modelValue: _ctx.addConnector,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addConnector) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_AddConnector, { companyId: _ctx.companyId }, null, 8, ["companyId"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["cols"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}